import {
    GET_INTEGRATIONS,
    SET_INTEGRATIONS,
    GET_INTEGRATION,
    SET_INTEGRATION,
    UPDATE_INTEGRATION_SETTINGS,
    STORE_INTEGRATION,
    ADD_INTEGRATION,
    SET_ORGANIZATION_OPTIONS,
    SET_KINDERGARTEN_OPTIONS,
    STORE_INTEGRATION_CLIENT,
    ADD_INTEGRATION_CLIENT,
    GET_INTEGRATION_CLIENTS,
    SET_INTEGRATION_CLIENTS,
    DELETE_INTEGRATION_CLIENT,
    REMOVE_INTEGRATION_CLIENT,
    UPDATE_INTEGRATION_CLIENT,
    SET_INTEGRATION_CLIENT,
    GET_INTEGRATION_MODULES,
    GET_INTEGRATION_MODULE_CLIENTS,
    GET_INTEGRATION_MODULE,
    STORE_INTEGRATION_MODULE,
    STORE_INTEGRATION_MODULE_CLIENT,
    UPDATE_INTEGRATION_MODULE_CLIENT,
    GET_INTEGRATION_PARTNERS,
    SET_INTEGRATION_PARTNERS,
    STORE_INTEGRATION_PARTNER,
    ADD_INTEGRATION_PARTNER,
    UPDATE_INTEGRATION_PARTNER,
    SET_INTEGRATION_PARTNER,
    DELETE_INTEGRATION_MODULE_CLIENT,
    UPDATE_INTEGRATION_MODULE
} from './actions';
import IntegrationsService from '@services/integration.service';
import Vue from 'vue';


const defaultState = () => {
    return {
        integrations: [],
        integration: {},
        clients: { data: [] },
        kindergartens: [],
        organizations: [],
        partners: []
    };
};
const state = defaultState;
const mutations = {
    [SET_INTEGRATIONS](state, data) {
        state.integrations = data;
    },
    [SET_INTEGRATION](state, integration) {
        state.integration = integration;
    },
    [ADD_INTEGRATION](state, integration) {
        state.integrations.push(integration);
    },
    [SET_ORGANIZATION_OPTIONS](state, options) {
        state.organizations = options;
    },
    [SET_KINDERGARTEN_OPTIONS](state, options) {
        state.kindergartens = options;
    },
    [ADD_INTEGRATION_CLIENT](state, client) {
        state.clients.data.push(client);
    },
    [SET_INTEGRATION_CLIENT](state, client) {
        const index = state.clients.data.findIndex(d => d.id === client.id);
        if(index > -1) {
            Vue.set(state.clients.data, index, client);
        }
    },
    [SET_INTEGRATION_CLIENTS](state, clients) {
        state.clients = clients;
    },
    [REMOVE_INTEGRATION_CLIENT](state, id) {
        const index = state.clients.data.findIndex(client => client.id === id);
        if(index !== -1) {
            state.clients.data.splice(index, 1);
        }
    },
    [SET_INTEGRATION_PARTNERS] (state, partners) {
        state.partners = partners;
    },
    [ADD_INTEGRATION_PARTNER] (state, partner) {
        state.partners.push(partner);
    },
    [SET_INTEGRATION_PARTNER] (state, {id, data}) {
        const index = state.partners.findIndex(d => d.id === id);
        if(index > -1) {
            Vue.set(state.partners, index, data);
        }
    }
};
const actions = {
    [GET_INTEGRATIONS]({commit}) {
        commit(SET_INTEGRATIONS, []);
        return IntegrationsService.getIntegrations().then(res => {
            commit(SET_INTEGRATIONS, res);
        });
    },
    [GET_INTEGRATION_MODULES]({commit}) {
        commit(SET_INTEGRATIONS, []);
        return IntegrationsService.getIntegrationModules().then(res => {
            commit(SET_INTEGRATIONS, res);
        });
    },
    [GET_INTEGRATION]({commit}, id) {
        return IntegrationsService.getIntegration(id).then(res => {
            commit(SET_INTEGRATION, res.integration);
            commit(SET_ORGANIZATION_OPTIONS, res.organizations);
            commit(SET_KINDERGARTEN_OPTIONS, res.kindergartens);
        });
    },
    [GET_INTEGRATION_MODULE]({commit}, id) {
        return IntegrationsService.getIntegrationModule(id).then(res => {
            commit(SET_INTEGRATION, res.module);
            commit(SET_ORGANIZATION_OPTIONS, res.organizations);
            commit(SET_KINDERGARTEN_OPTIONS, res.kindergartens);
            commit(SET_INTEGRATION_PARTNERS, res.partners);
        });
    },
    [UPDATE_INTEGRATION_MODULE]({commit, getters}, data) {
        return IntegrationsService.updateIntegrationModule(getters.integration.id, data).then(res => {
            commit(SET_INTEGRATION, res);
        });
    },
    [GET_INTEGRATION_MODULE_CLIENTS]({commit, getters}, queryObj) {
        commit(SET_INTEGRATION_CLIENTS, { data: [] });
        return IntegrationsService.getIntegrationModuleClients(getters.integration.id, queryObj).then(res => {
            commit(SET_INTEGRATION_CLIENTS, res);
        });
    },
    [UPDATE_INTEGRATION_SETTINGS]({commit}, {id, form}) {
        return IntegrationsService.updateIntegrationSettings(id, form).then(res => {
            commit(SET_INTEGRATION, res);
        });
    },
    [STORE_INTEGRATION]({commit}, data) {
        return IntegrationsService.addIntegration(data).then(res => {
            commit(ADD_INTEGRATION, res);
        });
    },
    [STORE_INTEGRATION_MODULE]({commit}, data) {
        return IntegrationsService.addModule(data).then(res => {
            commit(ADD_INTEGRATION, res);
        });
    },
    [GET_INTEGRATION_CLIENTS]({commit, getters}, queryObj) {
        commit(SET_INTEGRATION_CLIENTS, { data: [] });
      return IntegrationsService.getIntegrationClients(getters.integration.id, queryObj).then(res => {
          commit(SET_INTEGRATION_CLIENTS, res);
      });
    },
    [STORE_INTEGRATION_CLIENT]({commit, getters}, data) {
        return IntegrationsService.addIntegrationClient(getters.integration.id, data).then(res => {
            commit(ADD_INTEGRATION_CLIENT, res);
        });
    },
    [STORE_INTEGRATION_MODULE_CLIENT]({commit, getters}, data) {
        return IntegrationsService.addIntegrationModuleClient(getters.integration.id, data).then(res => {
            commit(ADD_INTEGRATION_CLIENT, res);
        });
    },
    [UPDATE_INTEGRATION_CLIENT]({commit}, {id, form}) {
        return IntegrationsService.updateIntegrationClient(id, form).then(res => {
            commit(SET_INTEGRATION_CLIENT, res);
        });
    },
    [UPDATE_INTEGRATION_MODULE_CLIENT]({commit}, {id, form}) {
        return IntegrationsService.updateIntegrationModuleClient(id, form).then(res => {
            commit(SET_INTEGRATION_CLIENT, res);
        });
    },
    [DELETE_INTEGRATION_CLIENT]({commit}, id) {
        return IntegrationsService.deleteIntegrationClient(id).then(() => {
            commit(REMOVE_INTEGRATION_CLIENT, id);
        });
    },
    [DELETE_INTEGRATION_MODULE_CLIENT]({commit}, id) {
        return IntegrationsService.deleteIntegrationModuleClient(id).then(() => {
            commit(REMOVE_INTEGRATION_CLIENT, id);
        });
    },
    [GET_INTEGRATION_PARTNERS]({commit}) {
        commit(SET_INTEGRATION_PARTNERS, []);
        return IntegrationsService.getIntegrationPartners().then(res => {
            commit(SET_INTEGRATION_PARTNERS, res);
        });
    },
    [STORE_INTEGRATION_PARTNER]({commit}, data) {
        return IntegrationsService.addIntegrationPartner(data).then(res => {
            commit(ADD_INTEGRATION_PARTNER, res);
        });
    },
    [UPDATE_INTEGRATION_PARTNER]({commit}, {partnerId, data}) {
        return IntegrationsService.updateIntegrationPartner(partnerId, data).then(res => {
            commit(SET_INTEGRATION_PARTNER, {id: partnerId, data: res});
        });
    }
};
const getters = {
    integrations: state => state.integrations,
    integration: state => state.integration,
    orgClientOptions: state => state.organizations,
    kindergartenClientOptions: state => state.kindergartens,
    integrationClients: state => state.clients,
    integrationPartners: state => state.partners

};

export default {
    state,
    mutations,
    actions,
    getters
};
